<template>


  <div id="property-management" class="flex flex-wrap-reverse items-center data-list-btn-container">

    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" />


    <vs-table ref="table" multiple v-model="selected" :max-items="itemsPerPage" search :data="properties">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <v-select name="user_group" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary"
                    v-model="user_group" :options="user_group_options" :clearable="false" @input="onUserGroupChange"></v-select>
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ properties.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : properties.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="code">Code</vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="type">Type</vs-th>
        <vs-th sort-key="active">Status</vs-th>
        <vs-th>Action</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td>
            <p class="product-name font-medium truncate">{{ tr.code }}</p>
          </vs-td>

          <vs-td>
            <p class="product-category">{{ tr.name | title }}</p>
          </vs-td>

          <vs-td>
            <p class="product-category">{{ tr.property_type | title }}</p>
          </vs-td>

          <vs-td>
            <p class="product-category">{{ getStatus(tr.active) | title }}</p>
          </vs-td>

          <vs-td class="whitespace-no-wrap">
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />
          </vs-td>

        </vs-tr>
        </tbody>
      </template>
    </vs-table>

  </div>

</template>

<script>

import vSelect from 'vue-select'
import DataViewSidebar from './DataViewSidebar'

export default {
  components: {
    'v-select': vSelect,
    DataViewSidebar
  },
  data () {
    return {
      propertyId:null,
      name: '',
      property_type: '',
      is_required: 0,
      is_readonly: 0,
      user_group: {label: 'Admin', value: 1 },
      user_group_options: [{label: 'Admin', value: 4 }, {label: 'Owner', value: 3 }, {label: 'Restaurant Owner', value: 2 }],
      addNewDataSidebar: false,
      sidebarData: {},

      selected: [],
      // products: [],
      itemsPerPage: 20,
      isMounted: false
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.user_group !== ''
    },
    properties () {
      return this.$store.state.api.properties
    },
    property_types () {
      return this.$store.state.api.property_types
    },
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.properties.length
    }
  },
  mounted () {
    this.getPropertyTypes()
    this.propertyList(1)
    this.user_group.value = 1
  },
  methods: {
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val

      if (val === false) {
        this.propertyList(this.user_group.value)
      }
    },
    getStatus (active) {
      if (active === 1) {
        return 'Active'
      } else {
        return 'Passive'
      }
    },
    addNewData () {
      this.sidebarData = {}
      this.sidebarData.add = true
      this.sidebarData.property_types = this.property_types
      this.sidebarData.user_group = this.user_group.value
      this.toggleDataSidebar(true)
    },
    deleteData (id) {
      const obj = {
        propertyId: id
      }
      this.$store.dispatch('api/removeProperty', obj)
        .then(() => {
          this.propertyList(this.user_group.value)
        })
        .catch(err => { console.error(err) })
    },
    editData (data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      data.property_types = this.property_types
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    onUserGroupChange () {
      this.propertyList(this.user_group.value)
    },
    propertyList (group_id) {
      // Loading
      this.$vs.loading()

      const payload = {
        user_group: group_id
      }

      this.$store.dispatch('api/getPropertyList', payload)
        .then(() => {
          this.$vs.loading.close()

        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    getPropertyTypes () {
      // Loading
      this.$vs.loading()

      this.$store.dispatch('api/getPropertyTypes')
        .then(() => {
          this.$vs.loading.close()

        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    }
  }
}

</script>

<style lang="scss">
#property-management{
  .vs--single.vs--open .vs__selected{
    position: initial;
  }
  .vs-table-primary{
    width:100%;
  }
}
</style>
